import comSpSkeleton from "../../../../engines/components/comSpSkeleton";
import O1HD from "../../../../engines/gameEngine";
import stallPrefab from "./stallPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class stallPeople extends cc.Component {

    @property({type:comSpSkeleton,displayName:"人物动画"})
    peopleAni:comSpSkeleton = null;

    @property({type:cc.Node,displayName:"说话节点"})
    chatNode:cc.Node = null;

    @property({type:cc.RichText,displayName:"说话文本"})
    lb_Chat:cc.RichText = null;
    
    @property({type:stallPrefab,displayName:"商店页面"})
    stall:stallPrefab = null;

    targetPos:cc.Vec2 = null;

    onLoad(){
        this.createOneTargetPos();
    }

    createOneTargetPos(){
        let randY:number = Math.random() * 130 + 20;
        this.node.y = randY;
        this.targetPos = this.node.x < 0 ? cc.v2(750,randY) : cc.v2(-750,randY);
        this.peopleMoveTime = Math.random() * 100 + 150;
    }

    buyPoint:cc.Vec2 = cc.v2(300,0);

    peopleMoveTime:number = 300;

    onePeopleNoBuyAction(){
        cc.Tween.stopAllByTarget(this.node);
        this.peopleAni.playAnimation("Walk").start(true);
        this.peopleAni.node.scaleX = this.node.x < this.targetPos.x ? -1:1;
        let needTime:number = this.node.getPosition().sub(this.targetPos).mag() / this.peopleMoveTime;
        //@ts-ignore
        cc.tween(this.node).to(needTime,{position:this.targetPos}).call(()=>{
            this.createOneTargetPos();
            this.onePeopleNoBuyAction();
        }).start();
    }

    onePeopleBuyAction(){
        return new Promise<void>(resolve=>{
            cc.Tween.stopAllByTarget(this.node);
            this.peopleAni.playAnimation("Walk").start(true);
            this.peopleAni.node.scaleX = this.node.x < this.buyPoint.x ? -1:1;
            let needTime:number = this.node.getPosition().sub(this.buyPoint).mag() / this.peopleMoveTime;
            //@ts-ignore
            cc.tween(this.node).to(needTime,{position:this.buyPoint}).call(()=>{
                this.peopleAni.node.scaleX = 1;
                this.peopleAni.playAnimation("Idle").start(true);
                resolve();
            }).start();
        });
    }

    showChat(chatStr:string,isAutoHide:boolean = false,autoHideTime:number = 2){
        return new Promise<void>(resolve=>{
            this.chatNode.active = true;
            this.unschedule(this.hideChatFun);
            this.lb_Chat.string = chatStr;
            this.chatNode.scale = 0;
            cc.tween(this.chatNode).to(0.2,{scale:1},{easing:cc.easing.backOut}).call(()=>{
                if(!isAutoHide){
                    resolve();
                }
            }).start();
            if(isAutoHide){
                this.hideChatFun = async ()=>{
                    await this.hideChat();
                    resolve();
                }
                this.scheduleOnce(this.hideChatFun,autoHideTime);
            }
        });
    }

    hideChatFun:()=>void = null;

    hideChat(){
        return new Promise<void>(resolve=>{
            cc.tween(this.chatNode).to(0.2,{scale:0},{easing:cc.easing.backIn}).call(resolve).start();
        });
    }

    update(): void {
        this.node.zIndex = O1HD.Canvas().height/2 - this.node.y;
    }
    
}
